// extracted by mini-css-extract-plugin
export default {"button":"doku_button__rEA2O"};